import { render } from "./mvt-estpriceitem.vue?vue&type=template&id=07b1fbae"
import script from "./mvt-estpriceitem.js?vue&type=script&lang=js"
export * from "./mvt-estpriceitem.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__